import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import "./VisionSection.css";

const VisionSection = () => {
  const sectionRef = useRef(null);
  const { scrollYProgress } = useScroll({
    target: sectionRef,
    offset: ["start end", "end start"],
  });

  // Faster parallax effect
  const y = useTransform(scrollYProgress, [0, 1], [0, -200]);

  // Animation variants for text
  const textVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: "easeOut",
      },
    },
  };

  return (
    <section ref={sectionRef} className="vision-section">
      <motion.div className="vision-background" style={{ y }}></motion.div>
      <div className="vision-content-container">
        <motion.div
          className="vision-content"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
        >
          <motion.h2 className="vision-title" variants={textVariants}>
            <span className="yellow-gradient-text">Our Vision</span>
            <span className="arrow">→</span>
          </motion.h2>
          <motion.h3 className="vision-subtitle" variants={textVariants}>
            Driving Directional Force
          </motion.h3>
          <motion.p className="vision-description" variants={textVariants}>
            In a digital landscape defined by noise, 'Kynetic' represents clear,
            directional force. We started this agency to solve a specific
            problem: great brands getting stuck in static strategies. We exist
            to break the cycle and propel your business toward its revenue
            goals.
          </motion.p>
        </motion.div>
      </div>
    </section>
  );
};

export default VisionSection;
